import React, {useState} from 'react';
import styles from './AppBar.module.css';
import useDismissableMenu from './useDismissableMenu';
import {MenuPanel, MenuLink, MenuButton, MenuDivider, MenuLabel} from './MenuPanel';
import {DownloadIcon, KebabIcon} from '../marketing/icons/Icons';
import {CREATE_PAGE_ROUTE, HOW_TO_ROUTE} from '../marketing/routes';

// Mobile app bar's "More" popover: everything that doesn't fit as its own
// button at 390px width. Flat list (no nested submenus) per the brief.
const MoreMenu = ({authentication, onDownload, onPageDetails}) => {
    const [open, setOpen] = useState(false);
    const {triggerRef, menuRef} = useDismissableMenu(open, () => setOpen(false));

    const closeThen = (fn) => () => {
        setOpen(false);
        if (fn) fn();
    };

    return (
        <div className={styles.moreWrap}>
            <button
                ref={triggerRef}
                type="button"
                aria-label="More: download, page details, help"
                aria-haspopup="menu"
                aria-expanded={open}
                className={styles.iconButton}
                onClick={() => setOpen((o) => !o)}
            >
                <KebabIcon/>
            </button>
            {open && (
                <MenuPanel ref={menuRef} label="More">
                    <MenuButton onClick={closeThen(onDownload)}>
                        <DownloadIcon/>Download page
                    </MenuButton>
                    <MenuButton onClick={closeThen(onPageDetails)}>Page details</MenuButton>
                    <MenuLink to={CREATE_PAGE_ROUTE}>New page</MenuLink>
                    <MenuLink to={HOW_TO_ROUTE}>How pages work</MenuLink>
                    <MenuDivider/>
                    <MenuLabel>{authentication?.name || authentication?.email}</MenuLabel>
                    {authentication?.organisation ? (
                        <MenuLink to={`/organisations/${authentication.organisation.id}`}>
                            {authentication.organisation.name}
                        </MenuLink>
                    ) : (
                        <MenuLink to="/createOrganisation">Create organisation</MenuLink>
                    )}
                    {authentication?.features?.admin && <MenuLink to="/admin">Admin</MenuLink>}
                    <MenuLink to="/logout">Sign out</MenuLink>
                </MenuPanel>
            )}
        </div>
    );
};

export default MoreMenu;
